module.exports = "/images/Homepage-Missing BrickM.jpg";